import React, { Component } from 'react';
import classnames from 'classnames';
import { mergeStyles } from 'wix-rich-content-common';
import { LabeledToggle, SelectionListItem, SettingsMobileHeader, SettingsPanelHeader, SettingsSection, SettingsSeparator, SelectionList, SettingsPanelFooter } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { PDF_OPTIONS, PDF_CUSTOMIZATIONS } from '../pdfViewer/pdfConsts.js';
import fullViewerIcon from '../icons/fullViewerIcon.js';
import miniViewerIcon from '../icons/miniViewerIcon.js';

var css_248z = ".B4-le{color:var(--ricos-settings-text-color,#333);display:flex;flex:1 1 auto;flex-direction:column;position:absolute;z-index:5}[dir] .B4-le{background:#fff}[dir=ltr] .B4-le{left:0;right:0;text-align:left}[dir=rtl] .B4-le{left:0;right:0;text-align:right}[dir] .sZur0{margin-bottom:5px}.r1K9h{width:100%}[dir] .r1K9h{margin:70px auto 100px}[dir] ._8l83J{padding:0 24px}@media only screen and (max-width:640px){[dir] [data-query=media] ._8l83J{padding:0 20px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] [data-query=container] ._8l83J{padding:0 20px}}}@container (width < 640px){[dir] [data-query=container] ._8l83J{padding:0 20px}}[dir] .u7N4z{margin:0 auto auto}@supports not (display:grid){.SrUYW{display:inline-block;width:25%}[dir] .SrUYW{margin-bottom:21px}}@supports (display:grid){.y8s4r{column-gap:4px;grid-template-columns:100px 100px;grid-template-rows:85px;row-gap:12px}}";
var styles = {"fileUploadSettings":"B4-le","fileUploadSettingsLabel":"sZur0","fileUploadSettings_scrollContainer":"r1K9h","settingsBodyWrapper":"_8l83J","fileUploadSettings_mobile":"u7N4z","pdfViewModeSelector_option":"SrUYW","pdfViewModeSelector_grid":"y8s4r"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class FileUploadSettings extends Component {
  constructor(props) {
    var _a;
    super(props);
    this.renderToggle = ({ toggleKey, labelKey, dataHook, isChecked, onChange }) => {
      const { theme, t } = this.props;
      return /* @__PURE__ */ React.createElement("div", { key: toggleKey }, /* @__PURE__ */ React.createElement(
        LabeledToggle,
        {
          theme,
          checked: isChecked(),
          label: t(labelKey),
          onChange,
          dataHook
        }
      ));
    };
    this.pdfViewerToggleData = {
      toggleKey: "isPDFViewerEnabled",
      labelKey: "FileUploadPlugin_Settings_EnablePDFViewer_Label",
      dataHook: "fileUploadPDFViewerToggle",
      isChecked: () => {
        const { viewMode = PDF_OPTIONS.NONE } = this.props.componentData.pdfSettings || {};
        return this.modalsWithEditorCommands ? viewMode !== PDF_OPTIONS.NONE : this.state.pdfView !== PDF_OPTIONS.NONE;
      },
      onChange: () => {
        const pdfSettings = this.props.componentData.pdfSettings;
        const { viewMode: currentViewMode = PDF_OPTIONS.NONE } = pdfSettings || {};
        const viewMode = currentViewMode === PDF_OPTIONS.NONE ? PDF_OPTIONS.FULL : PDF_OPTIONS.NONE;
        if (this.modalsWithEditorCommands) {
          this.props.updateData({
            pdfSettings: __spreadProps(__spreadValues({}, pdfSettings), {
              viewMode
            })
          });
        } else {
          this.setState(({ pdfView }) => {
            return pdfView === PDF_OPTIONS.NONE ? { pdfView: PDF_OPTIONS.FULL } : { pdfView: PDF_OPTIONS.NONE };
          });
        }
      }
    };
    this.toggleData = [
      {
        toggleKey: PDF_CUSTOMIZATIONS.DOWNLOAD,
        labelKey: "FileUploadPlugin_Settings_ShowDownloadPDF_Label",
        dataHook: "fileUploadShowDownloadPDFToggle",
        isChecked: () => {
          const {
            componentData: { pdfSettings }
          } = this.props;
          return this.modalsWithEditorCommands && pdfSettings ? !(pdfSettings == null ? void 0 : pdfSettings[PDF_CUSTOMIZATIONS.DOWNLOAD]) : this.state.showDownloadPDF;
        },
        onChange: () => {
          const {
            componentData: { pdfSettings = {} }
          } = this.props;
          if (this.modalsWithEditorCommands && pdfSettings) {
            this.props.updateData({
              pdfSettings: __spreadProps(__spreadValues({}, pdfSettings), {
                [PDF_CUSTOMIZATIONS.DOWNLOAD]: !pdfSettings[PDF_CUSTOMIZATIONS.DOWNLOAD]
              })
            });
          } else {
            this.setState(({ showDownloadPDF }) => {
              return { showDownloadPDF: !showDownloadPDF };
            });
          }
        }
      },
      {
        toggleKey: PDF_CUSTOMIZATIONS.PRINT,
        labelKey: "FileUploadPlugin_Settings_ShowPrintPDF_Label",
        dataHook: "fileUploadShowPrintPDFToggle",
        isChecked: () => {
          const {
            componentData: { pdfSettings }
          } = this.props;
          return this.modalsWithEditorCommands && pdfSettings ? !pdfSettings[PDF_CUSTOMIZATIONS.PRINT] : this.state.showPrintPDF;
        },
        onChange: () => {
          const {
            componentData: { pdfSettings = {} }
          } = this.props;
          if (this.modalsWithEditorCommands && pdfSettings) {
            this.props.updateData({
              pdfSettings: __spreadProps(__spreadValues({}, pdfSettings), {
                [PDF_CUSTOMIZATIONS.PRINT]: !pdfSettings[PDF_CUSTOMIZATIONS.PRINT]
              })
            });
          } else {
            this.setState(({ showPrintPDF }) => {
              return { showPrintPDF: !showPrintPDF };
            });
          }
        }
      }
    ];
    this.revertComponentData = () => {
      var _a;
      const { componentData, helpers, pubsub } = this.props;
      if (this.initialState) {
        const { pdfView, showDownloadPDF, showPrintPDF } = this.initialState;
        const initialComponentData = __spreadProps(__spreadValues({}, componentData), {
          pdfSettings: {
            viewMode: pdfView,
            disableDownload: !showDownloadPDF,
            disablePrint: !showPrintPDF
          }
        });
        pubsub.update("componentData", initialComponentData);
        this.setState(__spreadValues({}, this.initialState));
      }
      (_a = helpers == null ? void 0 : helpers.closeModal) == null ? void 0 : _a.call(helpers);
    };
    this.onCancel = () => {
      this.modalsWithEditorCommands ? this.props.onCancel() : this.revertComponentData();
    };
    this.onSave = () => {
      this.modalsWithEditorCommands ? this.props.onSave() : this.onDoneClick();
    };
    this.onDoneClick = () => {
      var _a;
      const { helpers, componentData, pubsub } = this.props;
      const { pdfView, showDownloadPDF, showPrintPDF } = this.state;
      const newComponentData = __spreadProps(__spreadValues({}, componentData), {
        pdfSettings: {
          viewMode: pdfView,
          disableDownload: !showDownloadPDF,
          disablePrint: !showPrintPDF
        }
      });
      pubsub.update("componentData", newComponentData);
      (_a = helpers == null ? void 0 : helpers.closeModal) == null ? void 0 : _a.call(helpers);
    };
    this.renderOption = ({ item, selected }) => /* @__PURE__ */ React.createElement(SelectionListItem, { label: item.name, selected, icon: /* @__PURE__ */ React.createElement(item.icon, null) });
    this.getSelectionListOptions = (t) => {
      return [
        {
          option: PDF_OPTIONS.FULL,
          name: t("FileUploadPlugin_Settings_FullPDFViewer_Label"),
          icon: fullViewerIcon,
          dataHook: `PDFOptions_${PDF_OPTIONS.FULL}`,
          subText: t("FileUploadPlugin_Settings_FullPDFViewer_SubText")
        },
        {
          option: PDF_OPTIONS.MINI,
          name: t("FileUploadPlugin_Settings_MiniPDFViewer_Label"),
          icon: miniViewerIcon,
          dataHook: `PDFOptions_${PDF_OPTIONS.MINI}`,
          subText: t("FileUploadPlugin_Settings_MiniPDFViewer_SubText")
        }
      ];
    };
    this.dataMapper = ({ option }) => ({ value: option });
    this.onPDFViewModeChange = (option) => {
      if (this.modalsWithEditorCommands) {
        const pdfSettings = this.props.componentData.pdfSettings;
        this.props.updateData({ pdfSettings: __spreadProps(__spreadValues({}, pdfSettings), { viewMode: option }) });
      } else {
        this.setState({ pdfView: option });
      }
    };
    this.state = this.propsToState(props);
    this.initialState = __spreadValues({}, this.state);
    const { theme, experiments = {} } = props;
    this.styles = mergeStyles({ styles, theme });
    this.modalsWithEditorCommands = !!((_a = experiments.tiptapEditor) == null ? void 0 : _a.enabled);
  }
  propsToState(props) {
    const {
      pdfSettings: {
        viewMode = PDF_OPTIONS.NONE,
        disableDownload = true,
        disablePrint = true
      } = {}
    } = props.componentData;
    return {
      pdfView: viewMode,
      showPrintPDF: !disablePrint,
      showDownloadPDF: !disableDownload
    };
  }
  render() {
    const {
      theme,
      t,
      isMobile,
      languageDir,
      componentData: { pdfSettings }
    } = this.props;
    const componentDataPDFView = (pdfSettings == null ? void 0 : pdfSettings.viewMode) || PDF_OPTIONS.NONE;
    const { pdfView } = this.state;
    const selectedOption = this.modalsWithEditorCommands ? componentDataPDFView : pdfView;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: this.styles.fileUploadSettings,
        "data-hook": "fileUploadSettings",
        dir: languageDir
      },
      isMobile ? /* @__PURE__ */ React.createElement(
        SettingsMobileHeader,
        {
          theme,
          onCancel: this.onCancel,
          onSave: this.onSave,
          t,
          title: t("FileUploadSettings_Header")
        }
      ) : /* @__PURE__ */ React.createElement(
        SettingsPanelHeader,
        {
          title: t("FileUploadSettings_Header"),
          onClose: this.revertComponentData
        }
      ),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classnames(styles.fileUploadSettings_scrollContainer, {
            [styles.fileUploadSettings_mobile]: isMobile
          })
        },
        /* @__PURE__ */ React.createElement("div", { className: this.styles.settingsBodyWrapper }, /* @__PURE__ */ React.createElement(
          SettingsSection,
          {
            theme,
            ariaProps: { "aria-label": "enable pdf viewer", role: "region" }
          },
          /* @__PURE__ */ React.createElement("div", { className: this.styles.fileUploadSettingsLabel }, this.renderToggle(this.pdfViewerToggleData))
        ), selectedOption !== PDF_OPTIONS.NONE ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SettingsSeparator, { top: true, bottom: true }), /* @__PURE__ */ React.createElement(
          SettingsSection,
          {
            headerText: t("FileUploadPlugin_Settings_PDFDisplayOptions"),
            theme,
            ariaProps: { "aria-label": "pdf viewer modes", role: "region" }
          },
          /* @__PURE__ */ React.createElement(
            SelectionList,
            {
              theme,
              className: styles.pdfViewModeSelector_grid,
              dataSource: this.getSelectionListOptions(t),
              dataMapper: this.dataMapper,
              renderItem: this.renderOption,
              value: selectedOption,
              onChange: this.onPDFViewModeChange,
              optionClassName: styles.pdfViewModeSelector_option,
              useNewSettingsUi: true
            }
          )
        ), /* @__PURE__ */ React.createElement(SettingsSeparator, { top: true }), /* @__PURE__ */ React.createElement(
          SettingsSection,
          {
            theme,
            ariaProps: { "aria-label": "pdf viewer customizations", role: "region" }
          },
          /* @__PURE__ */ React.createElement("div", { className: this.styles.fileUploadSettingsLabel }, this.toggleData.map((toggle) => this.renderToggle(toggle)))
        )) : null)
      ),
      !isMobile && /* @__PURE__ */ React.createElement(
        SettingsPanelFooter,
        {
          fixed: true,
          theme,
          cancel: this.onCancel,
          save: this.onSave,
          t
        }
      )
    );
  }
}

export { FileUploadSettings as default };
//# sourceMappingURL=file-upload-settings.js.map
